import { render } from "./SnackBackHandler.vue?vue&type=template&id=cc6331b6"
import script from "./SnackBackHandler.vue?vue&type=script&lang=js"
export * from "./SnackBackHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__